import { post, get } from "src/services/api";

export const sharePreview = async ({ params, payload }) => {
  try {
    return await post({ endpoint: `/accounts/${params.accountId}/assistants/${params.assistantId}/preview/share`, data: payload });
  }
  catch (error) {
    console.error(error);
    throw new Error();
  }
};

export const getPreviewLink = async (params) => {
  try {
    return await get({ endpoint: `/accounts/${params.accountId}/assistants/${params.assistantId}/preview/link`, params: { branchName: params.branchName } });
  }
  catch (error) {
    console.error(error);
    throw new Error();
  }
};

export const getPreviewBranchDeployer = async (params) => {
  try {
    return await get({ endpoint: `/accounts/${params.accountId}/assistants/${params.assistantId}/preview`, params: { branchName: params.branchName, releaseName: params.releaseName } });
  }
  catch (error) {
    console.error("Error fetching preview branch deployer", error);
    throw new Error();
  }
};

export const extendPreview = async ({ assistantId }) => {
  try {
    return await post({ endpoint: `/assistants/${assistantId}/deploy/preview`, data: {} });
  }
  catch (error) {
    console.error("Error occurred while extending preview", error);
    throw error;
  }
};

export const preparePreview = async ({ assistantId, pageName }) => {
  try {
    return await post({ endpoint: `/assistants/${assistantId}/deploy/preview`, data: {}, headers: { pageName } });
  }
  catch (error) {
    console.error("Error occurred while preparing preview", error);
    throw error;
  }
};
